import { render, staticRenderFns } from "./SellgoodsItem.vue?vue&type=template&id=72c3fe92&scoped=true&"
import script from "./SellgoodsItem.vue?vue&type=script&lang=js&"
export * from "./SellgoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./SellgoodsItem.vue?vue&type=style&index=0&id=72c3fe92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3fe92",
  null
  
)

export default component.exports